// extracted by mini-css-extract-plugin
export default {"menu-category-header-holder":"MenuCategoryHeader_menu-category-header-holder__qU5jO","menu-category-link-offset":"MenuCategoryHeader_menu-category-link-offset__eBLxR"};